const rawBaseUrl = import.meta.env.VITE_API_URL;
export const BASE_URL = rawBaseUrl ? rawBaseUrl.replace(/\/+$/, '') : '';
export const DEFAULT_VERSION = import.meta.env.VITE_DEFAULT_VERSION!;
export const SUPPORTED_LOCALES = ['en', 'nl'];
